import JscoreEventMap from './jscoreEvent.js';

import {
  postMessageToJscore,
  listenEventToJscore,
  unListenEventToJscore,
  postMessageToJscoreCbk,
  CallbackMap,
} from './postMessage.js';

const invokedEventMap = function (params) {
  if(JscoreEventMap[params.apiName]) {
    var data = JscoreEventMap[params.apiName](params);

    if(params.jcCbkId) {
      postMessageToJscoreCbk(params.apiName, params, data, null);
    }
  }else {
    JscoreEventMap['notFound'](params);
  }
}

// 初始化通信
export default function init () {
  // webview接收jscore事件，内部禁止调用，原生调用专属
  WxGameJsCoreBridge.invokeEvent = function (params) {
    if(typeof params === 'string') {
      params = JSON.parse(params);
    }
    console.log('webview-invokeEvent', params);
    if(params.wvCbkId && CallbackMap[params.wvCbkId]) {
      CallbackMap[params.wvCbkId](params.data);
      // 非listen事件只能回调一次
      if(!params.isListen) {
        delete CallbackMap[params.wvCbkId];
      }
    }else if(invokedEventMap){
      return invokedEventMap(params);
    }
  }

  // 全局发送api
  WxGameJsCoreBridge.postMessage = function (apiName, params, callback) {
    postMessageToJscore(apiName, params, callback);
  }

  // 全局事件监听
  WxGameJsCoreBridge.on = function (apiName, callback) {
    listenEventToJscore(apiName, callback);
  }

  // 全局事件监听
  WxGameJsCoreBridge.off = function (apiName, callback) {
    unListenEventToJscore(apiName, callback);
  }
};


/*

客户端对webview：
1、 webview发布事件给jscore
  WxGameWebviewBridge.postMessage({
    method: 'contact', // 'contact': 给jscore发消息
    params: {
      // 客户单需要解析的参数
      'apiName'    : 'request',  // 任务名：native对应任务名需要关注，否则 contact 不需要关注
      'sync'       : false,      // 是否同步

      // 各apiName下的参数
      params :  {
        'wvCbkId'    : 1
      }
    }
  })
2、 webview接收jscore事件
  WxGameWebviewBridge.invokedEvent(method, params)
    method: 'contact',
    params:  {apiName,sync, params, data: data}// 此处为 postMessage对应的params  data为获取的数据，客户端处理method='native'后需要调用该方法，需要将数据放入params.data
3、 webview与Native的通信保持之前的做法
*/
